import { render, staticRenderFns } from "./GlobalVariableMoveToFolder.vue?vue&type=template&id=757845c6"
import script from "./GlobalVariableMoveToFolder.vue?vue&type=script&lang=js"
export * from "./GlobalVariableMoveToFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports